(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-size-guide')) {
  customElements.define('lb-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const fallback = this.querySelector('.lb-guide');
      if (!fallback) {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
        return;
      }
      const panel = fallback.querySelector('.lb-guide__panel');
      const dialog = this.querySelector('.lb-guide-drawer');
      const trigger = this.querySelector('[data-lb-guide-open]');
      if (typeof dialog.showModal !== 'function') return;
      this.querySelector('.guide-mode').hidden = false;
      if (window.matchMedia('(max-width:600px)').matches) {
        const firstSize = panel.querySelector('details.size-card');
        const help = panel.querySelector('.lb-guide__help');
        if (firstSize) firstSize.open = true;
        if (help) help.open = true;
      }
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-guide-mode]');
        if (!button || !this.contains(button)) return;
        const cards = button.dataset.guideMode === 'cards';
        panel.querySelector('.size-cards').hidden = !cards;
        panel.querySelector('.all-measurements').hidden = cards;
        panel.querySelector('.guide-hint').hidden = !cards || Number(this.dataset.metrics) < 1;
        panel.querySelectorAll('[data-guide-mode]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
      this.dataset.ready = 'true';
      this.dialog = dialog;
      dialog.querySelector('.lb-guide-drawer__body').append(panel);
      fallback.hidden = true;
      trigger.hidden = false;
      const restoreScroll = () => {
        if (!this.scrollLock) return;
        document.documentElement.style.overflow = this.scrollLock.overflow;
        document.documentElement.style.paddingRight = this.scrollLock.paddingRight;
        this.scrollLock = null;
      };
      this.restoreScroll = restoreScroll;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        if (window.matchMedia('(max-width:600px)').matches && !this.mobileOpened) {
          const firstSize = panel.querySelector('details.size-card');
          const help = panel.querySelector('.lb-guide__help');
          if (firstSize) firstSize.open = true;
          if (help) help.open = true;
          this.mobileOpened = true;
        }
        const root = document.documentElement;
        const style = getComputedStyle(root);
        const scrollbar = window.innerWidth - root.clientWidth;
        this.scrollLock = { overflow: root.style.overflow, paddingRight: root.style.paddingRight };
        root.style.overflow = 'hidden';
        if (scrollbar > 0 && !style.scrollbarGutter.includes('stable')) {
          root.style.paddingRight = `${parseFloat(style.paddingRight) + scrollbar}px`;
        }
        dialog.showModal();
      });
      dialog.querySelectorAll('[data-lb-guide-close]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('button, a[href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])')].filter(element => !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) return;
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('close', () => {
        restoreScroll();
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll?.();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
